<!-- ? Header -->
<ion-header mode="md">
  <ion-toolbar color="white" mode="md" class="toolbar">
    <ion-buttons slot="start" mode="md" class="ion-no-margin">
      <!-- * Back -->
      <ion-button
        class="mpe-button-icon-circle ion-no-padding"
        size="default"
        mode="ios"
        shape="round"
        fill="clear"
        color="darkblue"
        (click)="onBack($event)"
      >
        <ion-icon name="previus-blue" class="icon-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <!-- * Titulo -->
    <ion-label mode="md" color="darkblue" class="title">
      {{ "Titles." + (promo.Bonificacion ? "bonus" : "promotion") | translate }}
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content color="gray" forceOverscroll="false">
  <!-- * Card de la promo principal -->
  <promotions-card
    [promo]="promo"
    [iwantit]="true"
    (promosCartEvent)="promosCart = $event"
    (productosPromocionEvent)="productosPromocion = $event"
    (cartPromoProductsEvent)="cartPromoProductsEvent($event)"
    (NivelesPromoEvent)="NivelesPromo = $event"
    (disabledEdit)="disabledEdit = $event"
    (cancelPromo)="onCancel($event)"
    (exchangeEvent)="exchange = $event"
    (levelStairs)="levelStairs = $event"
    (level)="level = $event"
  ></promotions-card>

  <ion-card
    mode="md"
    color="white"
    class="card-detail-promo"
    [ngStyle]="{'z-index': isIOS ? -1 : 1 }"
  >
    <ion-list mode="ios" lines="none">
      <!-- * Lista de Productos de la Promocion -->
      <ng-container>
        <!-- * Productos escalera -->
        <ng-container *ngIf="promo.TipoPromocion === 'ESCALERA'">
          <app-header-level
            [NivelesPromo]="promo.Niveles"
            [levelStairs]="levelStairs"
          ></app-header-level>

          <ng-container
            *ngFor="let product of productosPromocion; let j = index"
          >
            <row-product
              [product]="product"
              [clase]="
              j + 1 < productosPromocion.length
                ? 'separator-dashed'
                : 'separator'
            "
              [rangeSelector]="true"
              [maxRange]="
              product.Maximo - (cartPromoProducts | sumTotal: 'productos')
            "
              [productsUsesReference]="
              (cartPromoProducts
                | filterArray: product.id_producto:'id_producto')[0].productos
            "
              (productUse)="productUse($event)"
            ></row-product>
          </ng-container>
        </ng-container>

        <!-- * Productos dinamicos -->
        <ng-container
          *ngIf="promo.TipoPromocion === 'DINAMICO' || promo.TipoPromocion === 'BONIFICACION'"
        >
          <app-products-level
            [Niveles]="NivelesPromo"
            [productosPromocion]="productosPromocion"
            [cartPromoProducts]="cartPromoProducts"
            [level]="level"
            [disabledEdit]="disabledEdit"
            [isBonus]="promo.Bonificacion"
            (comeNivelProducts)="comeNivelProducts($event)"
          ></app-products-level>
        </ng-container>

        <!-- * Paquetes a canjear -->
        <ng-container *ngIf="canjeEnabled.isVisible">
          <how-many-redeem
            [max]="canjeEnabled.maximum"
            [initial]="intialCanje"
            [exchange]="exchange"
            [isCount]="canjeEnabled.isActive"
            [tipoPromocion]="promo.TipoPromocion"
            [promosCart]="promosCart"
            [productosPromocion]="cartPromoProducts"
            [isBonus]="promo.Bonificacion"
            (addExchange)="addExchange($event)"
          ></how-many-redeem>
        </ng-container>

        <!-- * Estatus de la promo -->
        <app-promo-status
          [exchange]="exchange"
          [isCheck]="canjeEnabled.isCheck"
          [promo]="promo"
          [Niveles]="NivelesPromo"
        ></app-promo-status>

        <!-- * Detalle del paquete -->
        <app-summary
          [exchange]="exchange"
          [productosPromocion]="cartPromoProducts"
          [isBonus]="promo.Bonificacion"
        ></app-summary>

        <!-- * Para agregar o limpiar -->
        <add-products-buttons
          [exchange]="exchange"
          [initial]="0"
          [promo]="promo"
          [promosCart]="promosCart"
          [productosPromocion]="cartPromoProducts"
          [Niveles]="NivelesPromo"
          (addPromo)="onAdd(true)"
          (addExchange)="addExchange($event)"
        ></add-products-buttons>
      </ng-container>
    </ion-list>
  </ion-card>
</ion-content>
